import Button from '@mui/material/Button';
import FadeIn from "react-fade-in/lib/FadeIn"
import { useDispatch, useSelector } from "react-redux";
import {
    setStepRedux,
    setOpenThemeRedux,
    getOpenThemeRedux,
    setSlidePageRedux,
    getSlidePageRedux,
    setSecondColorPickerOpenRedux,
    setPrimeColorPickerOpenRedux,
    getSecondColorPickerOpenRedux,
    getPrimeColorPickerOpenRedux,
    setCancleCreatePortalModalRedux,
    getCancleCreatePortalModalRedux,
    setCancleCreateThemePortalModalRedux,
    getCancleCreateThemePortalModalRedux,
    setAcceptCreatePortalModalRedux,
    getAcceptCreatePortalModalRedux,
    setSwitchActivePortalRedux,
    getSwitchActivePortalRedux,
    setBase64PortalLogoRedux,
    getBase64PortalLogoRedux,
    getPortalRedux,
} from "../../../libs/eduPortalManagementSlice";
import axios from "axios";
import { getBizID } from "../../../libs/todoSlice";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import fontColor from "../../../lib/fontColor";
import ErrorIcon from '@mui/icons-material/Error';
import './styleportal.css'
import { hex2rgb } from "string-color-converter";
import { rgbaObjectToHex } from "../../../lib/FormPortal/colorConvert";
import { isPortalSaveDisabled } from "../../../lib/FormPortal/portalFormValidation";
import PortalFormBody from "../../../lib/FormPortal/PortalFormBody";
import { getValidLoginMethods } from "../../../lib/FormPortal/loginMethodRules";

const EduPortalManagementEditPortal = () => {

    const dispatch = useDispatch()
    const biz_id = useSelector(getBizID)
    const portal = useSelector(getPortalRedux)
    const openTheme = useSelector(getOpenThemeRedux)
    const slidepage = useSelector(getSlidePageRedux)
    const primecolorpickeropen = useSelector(getPrimeColorPickerOpenRedux)
    const secondcolorpickeropen = useSelector(getSecondColorPickerOpenRedux)
    const canclecreateportalmodal = useSelector(getCancleCreatePortalModalRedux)
    const canclecreatethemeportalmodal = useSelector(getCancleCreateThemePortalModalRedux)
    const switchactiveportal = useSelector(getSwitchActivePortalRedux)
    const acceptcreateportalmodal = useSelector(getAcceptCreatePortalModalRedux)
    const base64portallogo = useSelector(getBase64PortalLogoRedux)
    const [autoApprove, setAutoApprove] = useState(true)
    const [formName, setFormName] = useState('')
    const [formType, setFormType] = useState('')
    const [active, setActive] = useState(true)
    const [retrieve, setRetrieve] = useState([])
    const [idp, setIDP] = useState([])
    const [editloginmethod, setEditLoginMethod] = useState([])
    const [link, setLink] = useState('')
    const [token, setToken] = useState('')
    const [useClientSecret, setUseClientSecret] = useState(false)
    const [clientKey, setClientKey] = useState('')
    const [secretKey, setSecretKey] = useState('')
    const [clientIDList, setClientIDList] = useState([])
    const [portalthemename, setPortalThemeNameValue] = useState('')
    const [portalthemeprimecolor, setPortalThemePrimeColorValue] = useState(rgbaObjectToHex({ r: 62, g: 148, b: 181, a: 1 }))
    const [portalthemesecondcolor, setPortalThemeSecondColorValue] = useState(rgbaObjectToHex({ r: 43, g: 161, b: 151, a: 1 }))
    const [redirect_url, setRedirectURL] = useState('')
    const [client_id, setClientID] = useState('')
    const [azureurl, setAzureURL] = useState('')
    const [googleurl, setGoogleURL] = useState('')
    const [facebookurl, setFacebookURL] = useState('')
    const [onecollaburl, setOneCollabURL] = useState('')
    const [portallogo, setPortalLogo] = useState('')
    const [portalthemeprimecolorpick, setPortalThemePrimeColorPick] = useState({})
    const [portalthemesecondcolorpick, setPortalThemeSecondColorPick] = useState({})
    const [isCopied, setIsCopied] = useState(false);
    const [useCA, setUseCA] = useState(false)
    const [timeleft, setTimeLeft] = useState(0)
    const [updateRealTime, setUpdateRealTime] = useState(false)

    const setStep = (action) => {
        dispatch(setStepRedux({
            step: action
        }))
    }

    const setOpenTheme = (action) => {
        dispatch(setOpenThemeRedux({
            openTheme: action
        }))
    }

    const setPortalThemeName = (action) => {
        setPortalThemeNameValue(action)
    }

    const setPortalThemePrimeColor = (action) => {
        setPortalThemePrimeColorValue(action)
    }

    const setPortalThemeSecondColor = (action) => {
        setPortalThemeSecondColorValue(action)
    }

    const setPrimeColorPickerOpen = (action) => {
        dispatch(setPrimeColorPickerOpenRedux({
            primecolorpickeropen: action
        }))
    }

    const setSecondColorPickerOpen = (action) => {
        dispatch(setSecondColorPickerOpenRedux({
            secondcolorpickeropen: action
        }))
    }

    const setSlidePage = (action) => {
        dispatch(setSlidePageRedux({
            slidepage: action
        }))
    }

    const setCancleCreatePortalModal = (action) => {
        dispatch(setCancleCreatePortalModalRedux({
            canclecreateportalmodal: action
        }))
    }

    const setCancleCreateThemePortalModal = (action) => {
        dispatch(setCancleCreateThemePortalModalRedux({
            canclecreatethemeportalmodal: action
        }))
    }

    const setSwitchActivePortal = (action) => {
        dispatch(setSwitchActivePortalRedux({
            switchactiveportal: action
        }))
    }

    const setAcceptCreatePortalModal = (action) => {
        dispatch(setAcceptCreatePortalModalRedux({
            acceptcreateportalmodal: action
        }))
    }

    const setBase64PortalLogo = (action) => {
        dispatch(setBase64PortalLogoRedux({
            base64portallogo: action
        }))
    }

    const [contact, setContact] = useState('')

    useEffect(() => {
        if (!portal) return;
        setPortalThemeName('')
        setPortalThemePrimeColor('')
        setPortalThemeSecondColor('')
        setBase64PortalLogo('')
        setFormName('')
        setFormType('')
        setAutoApprove(true)
        setRetrieve([])
        setActive(true)
        setEditLoginMethod([])
        setClientIDList([])
        setRedirectURL('')
        setClientID('')
        setLink('')
        setToken('')
        setAzureURL('')
        setGoogleURL('')
        setFacebookURL('')
        setUseCA(false)
        getIDP(portal.kind)
        setUseCA(portal.useCA)
        setOpenTheme(false)
        setAcceptCreatePortalModal(false)
        setCancleCreatePortalModal(false)
        setCancleCreateThemePortalModal(false)
        setSlidePage(1)
        setPrimeColorPickerOpen(false)
        setPrimeColorPickerOpen(false)
        setSecondColorPickerOpen(false)
        setPortalThemeName(portal.theme.name)
        setPortalThemePrimeColor(rgbaObjectToHex(portal.theme.primaryColor))
        setPortalThemeSecondColor(rgbaObjectToHex(portal.theme.secondaryColor))
        setPortalThemePrimeColorPick(rgbaObjectToHex(portal.theme.primaryColor))
        setPortalThemeSecondColorPick(rgbaObjectToHex(portal.theme.secondaryColor))
        setPortalLogo('')

        let newRetrieve = Array.isArray(portal.retrieve) ? portal.retrieve : [];

        if (Array.isArray(portal.retrieveData) && portal.retrieveData.some(item => item === "cid")) {
            newRetrieve = newRetrieve.map(item =>
                item.from === "OneID" ? { ...item, cid: 'cid' } : item
            );
        }
        if (Array.isArray(portal.retrieveData) && portal.retrieveData.some(item => item === "corporation_Id")) {
            newRetrieve = newRetrieve.map(item =>
                item.from === "OneID" ? { ...item, corporation_Id: 'corporation_Id' } : item
            );
        }
        if (Array.isArray(portal.retrieveData) && portal.retrieveData.some(item => item === "email")) {
            newRetrieve = newRetrieve.map(item =>
                item.from === "OneID" ? { ...item, email: 'email' } : item
            );
        }

        setRetrieve(newRetrieve)
        setBase64PortalLogo("data:image/png;base64," + portal.theme.logo)
        setFormName(portal.name)
        setFormType(portal.kind)
        setAutoApprove(portal.approvalMethod.autoApprove)
        setActive(portal.active)
        setEditLoginMethod(getValidLoginMethods(portal.loginMethod, portal.kind))
        setClientIDList(portal.approvalMethod.clientIDList)
        setRedirectURL(portal.redirectURL)
        setClientID(portal.clientID)
        setContact(portal.contact ?? '')
        setUpdateRealTime(portal.updateRealTime);
        if (Array.isArray(portal.retrieve) && portal.retrieve.find(item => item.from === "API")) {
            setLink(portal.retrieve.find(item => item.from === 'API')?.url)
            setToken(portal.retrieve.find(item => item.from === 'API')?.token)
        }
        if (Array.isArray(portal.retrieve) && portal.retrieve.find(item => item.from === "Azure")) {
            setAzureURL(portal.retrieve.find(item => item.from === 'Azure')?.url)
        }
        if (Array.isArray(portal.retrieve) && portal.retrieve.find(item => item.from === "Google")) {
            setGoogleURL(portal.retrieve.find(item => item.from === 'Google')?.url)
        }
        if (Array.isArray(portal.retrieve) && portal.retrieve.find(item => item.from === "Facebook")) {
            setFacebookURL(portal.retrieve.find(item => item.from === 'Facebook')?.url)
        }

        const apiEntry = Array.isArray(portal.retrieve) && portal.retrieve.find(item => item.from === 'API')
        if (apiEntry) {
            setUseClientSecret(Boolean(apiEntry.useClientSecret))
            setClientKey(apiEntry.clientKey ?? '')
            setSecretKey(apiEntry.secretKey ?? '')
        }
    }, [portal])

    useEffect(() => {
        if (formType === "general" || formType === "medical-pre-register" || formType === "time-attendance-pre-register") {
            setUseCA(false);
        }
        if (formType === "corporation-pre-register" && !retrieve.some(obj => obj.from === "OneID")) {
            setRetrieve([...retrieve, { from: "OneID", url: null, token: null, corporation_Id: "corporation_Id" }]);
        }
    }, [formType]);

    const editPortal = async () => {
        setTimeLeft(3)
        let timeLeftTemp = 3
        const interval = setInterval(() => {
            timeLeftTemp--
            setTimeLeft(timeLeftTemp);
        }, 1000);
        setTimeout(() => {
            clearInterval(interval);
            setTimeLeft(0);
        }, 3000);

        try {
            const oneIdObject = retrieve.find(item => item.from === "OneID");
            const retrieveData = []
            if (formType === "corporation-pre-register" && oneIdObject) {
                if (oneIdObject.cid) retrieveData.push(oneIdObject.cid)
                if (oneIdObject.corporation_Id) retrieveData.push(oneIdObject.corporation_Id)
                if (oneIdObject.email) retrieveData.push(oneIdObject.email)
            }

            var portalPayload = {
                name: formName,
                retrieveData: retrieveData,
                kind: formType,
                approvalMethod: {
                    autoApprove: autoApprove,
                    clientIDList: clientIDList
                },
                active: active,
                loginMethod: editloginmethod,
                retrieve: retrieve,
                redirectURL: redirect_url,
                clientID: client_id,
                contact: contact,
                useCA: useCA,
                _id: portal.id
            }
            if (formType === "connect-mail" || formType === "general-mail") {
                portalPayload.updateRealTime = updateRealTime
            }
            
            await axios({
                method: 'PATCH',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal`,
                data: {
                    business_id: biz_id,
                    portal: portalPayload,
                }

            })

            const formData = new FormData();
            formData.append('name', portalthemename === "" ? "default" : portalthemename)
            formData.append('primary_color', JSON.stringify(hex2rgb(portalthemeprimecolor)))
            formData.append('secondary_color', JSON.stringify(hex2rgb(portalthemesecondcolor)))
            formData.append('image_logo', portallogo)
            formData.append('portal_id', portal.id)
            formData.append('business_id', biz_id)

            await axios({
                method: 'PATCH',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal/theme`,
                data: formData
            })
            setStep('table')
            Swal.fire({
                title: 'บันทึก Portal สำเร็จแล้ว',
                icon: 'success'
            })

        } catch (err) {
            setStep('table')
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'บันทึก Portal ไม่สำเร็จ'
            })
        }
    }

    const getIDP = async (kind) => {
        try {
            const { data } = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/portal/idps`,
                params: { business_id: biz_id },
            });
            const idpList = data?.data?.idp_list ?? [];
            if (kind === "connect-mail") {
                setIDP(idpList.filter(value => value.name === "Google" || value.name === "Azure"));
            } else if (kind === "general-mail") {
                setIDP(idpList.filter(value => value.name !== "OneID"));
            } else {
                setIDP(idpList);
            }
        } catch (err) {
            setIDP([]);
        }
    };

    useEffect(() => {
        if (portallogo) {
            const fileReader = new FileReader();
            fileReader.onload = handleImageLoad;
            fileReader.readAsDataURL(portallogo);
        }
    }, [portallogo]);

    const handleImageLoad = (event) => {
        const image = new Image();
        image.src = event.target.result;

        image.onload = () => {
        };

        image.onerror = () => {
            Swal.fire({
                icon: 'error',
                title: 'ไฟล์ไม่ถูกต้อง',
                text: 'กรุณาอัปโหลดไฟล์ประเภท PNG JPG JPEG',
                className: 'swal2-container'
            })
            setPortalLogo('');
            setBase64PortalLogo("data:image/png;base64," + portal.theme.logo)
        };
    };

    const handleChangeImage = async (e) => {
        setPortalLogo(e.target.files[0])
        if (e.target.files[0]) {
            const maxSize = 2 * 1024 * 1024
            if (e.target.files[0].size > maxSize) {
                setPortalLogo("")
                e.target.value = "";
                Swal.fire({
                    icon: 'error',
                    title: 'ไฟล์รูปมีขนาดใหญ่เกินไป',
                    footer: 'ไฟล์ต้องมีขนาดไม่เกิน 2 MB'
                })
            }
        }
        const base64 = await toBase64(e.target.files[0])
        setBase64PortalLogo(base64)
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const urlLinkConfig = portal?.loginMethod
        ? {
            items: portal.loginMethod.map((item) => ({
                name: item.name,
                url: `${process.env.REACT_APP_URL_AUTHORIZE}/verify/business?biz_id=${biz_id}&form_id=${portal.id}&form_type=${portal.kind}&login_type=${item.name}&token_type=shared_token&client_id=${portal.clientID}&redirect_url=${portal.redirectURL}`,
            })),
            isCopied,
            onCopy: (url) => {
                navigator.clipboard.writeText(url)
                    .then(() => {
                        setIsCopied(true);
                        setTimeout(() => {
                            setIsCopied(false);
                        }, 2000);
                    })
                    .catch((error) => {
                        console.error('Error copying link:', error);
                    });
            },
        }
        : null;

    const formBodyProps = {
        mode: 'edit',
        primaryColor: portalthemeprimecolor,
        active,
        onRequestToggleActive: () => setSwitchActivePortal(true),
        formName,
        onFormNameChange: setFormName,
        onOpenTheme: () => setOpenTheme(true),
        formType,
        onFormTypeChange: setFormType,
        formTypeDisabled: true,
        useCA,
        onToggleUseCA: () => setUseCA((prev) => !prev),
        autoApprove,
        approvalMethodDisabled: true,
        onSetAutoApprove: setAutoApprove,
        clientIDList,
        setClientIDList,
        loginMethod: editloginmethod,
        onLoginMethodChange: setEditLoginMethod,
        idp,
        retrieveUrlSetters: {
            Azure: setAzureURL,
            Google: setGoogleURL,
            Facebook: setFacebookURL,
            OneCollab: setOneCollabURL,
        },
        retrieve,
        setRetrieve,
        retrieveFieldValues: {
            link, setLink,
            token, setToken,
            azureurl, setAzureURL,
            googleurl, setGoogleURL,
            facebookurl, setFacebookURL,
            onecollaburl, setOneCollabURL,
            useClientSecret, setUseClientSecret,
            clientKey, setClientKey,
            secretKey, setSecretKey,
        },
        redirectUrl: redirect_url,
        onRedirectUrlChange: setRedirectURL,
        clientId: client_id,
        onClientIdChange: setClientID,
        showUpdateRealTime: formType === 'connect-mail' || formType === 'general-mail',
        updateRealTime,
        onToggleUpdateRealTime: () => setUpdateRealTime((prev) => !prev),
        contact,
        onContactChange: setContact,
        urlLinkConfig,
        cancelPortalDialogProps: {
            open: canclecreateportalmodal,
            onClose: () => setCancleCreatePortalModal(false),
            title: 'คุณต้องการยกเลิก Portal form ใช่ไหม',
            message: 'หากคุณยกเลิกข้อมูลจะไม่บันทึก',
            onConfirm: () => setStep('table'),
            primaryColor: portalthemeprimecolor,
            titleFontWeight: '600',
            buttonRowMarginTop: '20px',
            buttonRowFontSize: '16px',
            buttonRowFontWeight: '500',
            cancelMarginRight: '20px',
        },
        acceptPortalDialogProps: {
            open: acceptcreateportalmodal,
            onClose: () => setAcceptCreatePortalModal(false),
            title: 'ต้องการบันทึกการแก้ไขข้อมูลใช่ไหม',
            message: 'คุณแน่ใจหรือไม่ว่าต้องการแก้ไขข้อมูล',
            onConfirm: () => editPortal(),
            loading: timeleft > 0,
            primaryColor: portalthemeprimecolor,
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
        },
        switchActiveDialogProps: {
            open: switchactiveportal,
            onClose: () => setSwitchActivePortal(false),
            title: active ? 'คุณต้องการให้สถานะ Inactive' : 'คุณต้องการให้สถานะ Active',
            message: active
                ? 'Portal form สถานะ inactive จะไม่สามารถใช้งานได้'
                : 'Portal form สถานะ active จะสามารถเข้าใช้งานได้',
            onConfirm: () => {
                setActive(!active);
                setSwitchActivePortal(false);
            },
            primaryColor: portalthemeprimecolor,
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
        },
        cancelThemeDialogProps: {
            open: canclecreatethemeportalmodal,
            onClose: () => setCancleCreateThemePortalModal(false),
            icon: <ErrorIcon style={{ width: '72px', height: '72px', color: '#F2BE47' }} />,
            title: 'คุณต้องการยกเลิก',
            message: 'หากคุณต้องการยกเลิกข้อมูลทั้งหมดจะหายไป',
            onConfirm: () => {
                setCancleCreateThemePortalModal(false);
                setOpenTheme(false);
                setPortalThemePrimeColorPick(portalthemeprimecolor);
                setPortalThemeSecondColorPick(portalthemesecondcolor);
            },
            primaryColor: portalthemeprimecolor,
            boxHeight: '256px',
            titleFontWeight: '600',
            titleMarginTop: '5px',
            buttonRowMarginTop: '30px',
            buttonRowFontWeight: null,
            cancelMarginRight: '20px',
        },
        themeModalProps: {
            open: openTheme,
            onClose: () => setOpenTheme(false),
            themeName: portalthemename,
            onThemeNameChange: setPortalThemeName,
            primaryColorPick: portalthemeprimecolorpick,
            onPrimaryColorPick: setPortalThemePrimeColorPick,
            secondaryColorPick: portalthemesecondcolorpick,
            onSecondaryColorPick: setPortalThemeSecondColorPick,
            primaryPickerOpen: primecolorpickeropen,
            onTogglePrimaryPicker: setPrimeColorPickerOpen,
            secondaryPickerOpen: secondcolorpickeropen,
            onToggleSecondaryPicker: setSecondColorPickerOpen,
            closeOtherPickerOnOpen: false,
            hasLogo: Boolean(base64portallogo),
            logoSrc: base64portallogo,
            onLogoChange: handleChangeImage,
            onLogoClear: () => setBase64PortalLogo(''),
            logoAccept: 'image/jpeg, image/png ,image/jpg',
            onResetTheme: () => {
                setPortalThemePrimeColorPick(rgbaObjectToHex(portal.theme.primaryColor));
                setPortalThemeSecondColorPick(rgbaObjectToHex(portal.theme.secondaryColor));
                setPortalLogo('');
            },
            slidePage: slidepage,
            setSlidePage: setSlidePage,
            slide1NavTop: '85%',
            committedPrimaryColor: portalthemeprimecolor,
            onRequestCancel: () => setCancleCreateThemePortalModal(true),
            onCommitPrimaryColor: setPortalThemePrimeColor,
            onCommitSecondaryColor: setPortalThemeSecondColor,
        },
    };

    return (
        <FadeIn>
            <PortalFormBody {...formBodyProps}>
                <div className="row">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '30px',
                        }}>
                        <Button
                            variant="outlined"
                            style={{
                                marginTop: '15px',
                                width: '156px',
                                height: '36px',
                                marginRight: '10px',
                                borderColor: portalthemeprimecolor,
                                color: portalthemeprimecolor
                            }}
                            sx={{
                                '&:hover': { borderColor: fontColor(portalthemeprimecolor) },
                                ...(!!portalthemesecondcolor ? { borderColor: portalthemeprimecolor, color: fontColor(portalthemeprimecolor) } : { background: '#053075' })
                            }}
                            onClick={() => { setCancleCreatePortalModal(true) }}
                        >ยกเลิก</Button>
                        <Button
                            variant="contained"
                            onClick={() => { setAcceptCreatePortalModal(true) }}
                            style={{
                                marginTop: '15px',
                                width: '156px',
                                height: '36px',
                            }}
                            sx={!!portalthemesecondcolor ? {
                                backgroundColor: `${portalthemeprimecolor} !important`,
                                color: fontColor(portalthemeprimecolor)
                            } : {
                                background: '#053075'
                            }}
                            disabled={isPortalSaveDisabled({
                                formName,
                                formType,
                                loginMethod: editloginmethod,
                                retrieve,
                                link,
                                token,
                                redirectUrl: redirect_url,
                                clientId: client_id,
                                azureUrl: azureurl,
                                googleUrl: googleurl,
                                facebookUrl: facebookurl,
                                useClientSecret, 
                                clientKey, 
                                secretKey,
                            })}>บันทึก</Button>
                    </div>
                </div>
            </PortalFormBody>
        </FadeIn>
    );
};

export default EduPortalManagementEditPortal